import {
  DashboardTourDatesEvents,
  VenueManagerShowsEvents,
} from "@punchup/analytics/mixpanel.types";

import { ShowComedianPairing, ShowInfoRow } from "../shows";
import { VenuePagesRow } from "../venue_pages";
import { trackEvent } from "@punchup/analytics";
import { extractTixologiEventId } from "@punchup/utils/extractTixologiEventId";
import { revalidatePathClient } from "@punchup/utils/vercel";

type CreateUpdateShowsRequest = {
  comedianRequested: string | null;
  venuePageRequested: string | null;
  shows: Omit<ShowInfoRow, "created_at">[];
  showComedianPairings: ShowComedianPairing[];
};

export const sharedUpdaterFunction = async (
  updatedValues: Omit<ShowInfoRow, "created_at">,
  showComedians: ShowComedianPairing[],
  { venuePage }: { venuePage: VenuePagesRow | null }
) => {
  const {
    id: showId,
    comedian_id,
    datetime,
    ticket_link,
    is_sold_out,
    metadata_text,
    venue,
    venue_id,
    location,
    vip_ticket_link,
    presale_code,
    flags,
    title,
    poster_img,
    published_at,
  } = updatedValues;

  const updaterIsVenueManager = !!venuePage?.id;

  const res = await fetch("/api/manager/tour-dates", {
    method: "POST",
    body: JSON.stringify({
      // If the updater is a venue manager we don't want to check
      // permissions for comedian ID, and viceversa
      comedianRequested: updaterIsVenueManager ? null : comedian_id,
      venuePageRequested: venuePage?.id || null,
      shows: [
        {
          id: showId,
          comedian_id,
          datetime,
          is_sold_out,
          venue_id,
          venue,
          location,
          ticket_link,
          poster_img,
          vip_ticket_link: vip_ticket_link || null,
          metadata_text: metadata_text || null,
          presale_code: presale_code || null,
          flags: flags || [],
          title: title || null,
          tixologi_event_id: extractTixologiEventId(ticket_link),
          published_at: published_at || null,
        },
      ],
      showComedianPairings: showComedians,
    } satisfies CreateUpdateShowsRequest),
  });
  if (!res.ok) {
    trackEvent(
      updaterIsVenueManager
        ? VenueManagerShowsEvents.TOUR_DATE_UPDATE_FAILED
        : DashboardTourDatesEvents.TOUR_DATE_UPDATE_FAILED,
      {
        showId,
        comedianId: comedian_id,
        venuePageId: venuePage?.id ?? null,
        error: await res.text().catch(() => "Unknown error"),
      }
    );
    throw new Error("Failed to update show");
  }

  // invalidate cache for venue page
  if (updaterIsVenueManager) {
    await revalidatePathClient(`/v/${venuePage?.slug}`);
  }

  trackEvent(
    updaterIsVenueManager
      ? VenueManagerShowsEvents.TOUR_DATE_UPDATE_SUCCESSFUL
      : DashboardTourDatesEvents.TOUR_DATE_UPDATE_SUCCESSFUL,
    {
      showId,
      datetime,
      venue,
      location,
      comedianId: comedian_id,
      venuePageId: venuePage?.id ?? null,
    }
  );
};
